import React from 'react'
import "./Hero.css"
const Hero = () => {
  return (
    <div className='flex flex-col flex-wrap w-full h-screen relative  justify-end  items-baseline ' id="home">
      <div className=' flex  flex-wrap flex-col w-full h-auto  justify-center items-center '>
        <div className='flex flex-col w-full h-full justify-center items-center text-white text-[20px] font-normal'>
          <h2 className=' text-center  text-2xl w-[70%]'>The Scribs are a collection of 10,000 unique animated designs which will resonate strongly with anyone who has sat in a classroom and scribbled in their free time</h2>
        </div>
        
      </div>
      <div className='bg-hero  w-full h-auto flex flex-row '>
          <div className=' flex w-full h-auto py-2 px-4 text-white'>
            <h3 className=' text-right w-full'>Public Sale <strong>02-09-2022</strong></h3>
          </div>
      </div>
    </div>
  )
}

export default Hero